import {
    Swiper,
    Navigation,
    EffectFade
} from 'swiper/js/swiper.esm.js';
import 'swiper/swiper.scss';
import 'swiper/src/components/effect-fade/effect-fade.scss'
import './interval';

Swiper.use([Navigation, EffectFade]);


export default class FacilityModal {
    content;
	slider;
	sliderIcon;
    modal;

    constructor(triggerSelector, content) {
        const items = document.querySelectorAll(triggerSelector);
        this.content = content;
        if (items && items.length) {
            this.create();
            items.forEach(item => {
                item.addEventListener('click', (e) => {
                    e.preventDefault();
                    this.show();
                })
            })

        }
    }

    create() {
        this.wrapper = document.createElement('div');
		this.wrapper.classList.add('swiper-wrapper');

        const prevBtn = document.createElement('div');
        prevBtn.classList.add('swiper-button-prev');

        const nextBtn = document.createElement('div');
        nextBtn.classList.add('swiper-button-next');

        const container = document.createElement('div');
        container.classList.add('swiper-container', 'facility-modal-slider');
        container.append(this.wrapper, prevBtn, nextBtn);

        const closeBtn = document.createElement('button');
        closeBtn.classList.add('facility-modal-close');
        closeBtn.addEventListener('click', (e) => {
            this.close();
        })
		closeBtn.innerHTML = '<span class="sr-only">Close</span>';

        this.modal = document.createElement('div');
        this.modal.classList.add('facility-modal');
        this.modal.append(container, closeBtn);

        document.body.append(this.modal);
        this.slider = new Swiper(container, {
            speed: 1200,
            spaceBetween: 0,
            slidesPerView: 1,
            preloadImages: true,
			effect: 'fade',
			preventClicks: false,
			preventClicksPropagation: false,
            fadeEffect: {
                crossFade: true
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        })
    }

    show() {
        this.content.images.forEach(image => {
            const slide = document.createElement('div');
			slide.classList.add('swiper-slide');
			
			const slideInner = document.createElement('div');
			slideInner.classList.add('swiper-slide-inner');
			slide.append(slideInner);

			const sliderIcon = document.createElement('div');
			sliderIcon.classList.add('swiper-slide-icon');
			const sliderIconImg = document.createElement('img');
			sliderIconImg.setAttribute('src', this.content.icon);
			sliderIcon.append(sliderIconImg);
			slideInner.append(sliderIcon);

			const slideInfo = document.createElement('div');
            slideInfo.classList.add('swiper-slide-info');
            slideInner.append(slideInfo);

            if (this.content.title) {
                const slideTitle = document.createElement('p');
                slideTitle.classList.add('slide-title');
                slideTitle.textContent = this.content.title;
                slideInfo.append(slideTitle);
			}

			if (this.content.code) {
                const slideTitle = document.createElement('p');
                slideTitle.classList.add('slide-code');
                slideTitle.textContent = this.content.code;
                slideInfo.append(slideTitle);
			}

            const slideImg = document.createElement('img');
            slideImg.classList.add('swiper-slide-img');
            slideImg.setAttribute('src', image);
            slideInner.append(slideImg);

			if (this.content.details) {
                const slideDetails = document.createElement('div');
				slideDetails.classList.add('swiper-slide-details');
				let detailsText = '';
				this.content.details.forEach((detail, index)=> {
					if(index === 0){
						detailsText += '<b>' + detail + '</b> | ';
					}else if(index + 1 === this.content.details.length) {
						detailsText += detail;
					}else{
						detailsText += detail + ' | ';
					}
				})
                slideDetails.innerHTML = detailsText;
                slideInner.append(slideDetails);
            }


            this.slider.appendSlide(slide);

        })
        this.modal.classList.add('open');
        this.slider.update();
    }

    close() {

        this.modal.classList.remove('open');
        requestTimeout(() => {
            document.body.classList.remove('overflow-hidden')
            this.slider.removeAllSlides();
        }, 300)

    }


}